import React, { useEffect, useState } from "react";
import { RefreshCw, DownloadCloud, Loader2, History, Save, Link } from "lucide-react";
import { toast } from "sonner";
import { reviewsApi, btnCls } from "./shared";

const HINT = {
  tripadvisor: "TripAdvisor işletme sayfanızın linki (tripadvisor.com/Attraction_Review-g…-d…-Reviews-….html). Tüm yorumlar Apify ile tam tarih + reviewer adıyla çekilir.",
  viator: "Viator ürünlerinizin TripAdvisor ürün sayfaları (tripadvisor.com/AttractionProductReview-g…-d…-….html) — Viator + TripAdvisor ortak yorum havuzu, Apify ile gün hassasiyetinde çekilir. Her satıra bir link.",
};

export default function TaSourceActions({ s, onChanged }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(null);
  useEffect(() => { setText((s.urls || []).join("\n")); }, [s.urls]);
  const dirty = text.trim() !== (s.urls || []).join("\n").trim();
  const p = s.progress || {};
  const running = s.running || s.last_status === "running";

  const run = async (fn, key, okMsg) => {
    setBusy(key);
    try { const d = await fn(); toast.success(typeof okMsg === "function" ? okMsg(d) : okMsg); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "İşlem başarısız"); }
    setBusy(null);
  };
  const save = () => run(() => reviewsApi.setSourceUrls(s.source, text.split(/\n+/)), "save", d => `${d.urls.length} link kaydedildi`);

  return (
    <div className="mt-3 space-y-2">
      <p className="text-[11px] text-slate-500 leading-relaxed">{HINT[s.source]}</p>
      <textarea value={text} onChange={e => setText(e.target.value)} rows={Math.min(6, Math.max(2, text.split("\n").length))} spellCheck={false}
        placeholder="https://www.tripadvisor.com/…" data-testid={`${s.source}-urls-input`}
        className="w-full bg-slate-900 border border-slate-700 text-slate-200 text-[11px] font-mono rounded-lg px-3 py-2 placeholder:text-slate-600 focus:border-blue-500 outline-none resize-y" />
      <div className="flex flex-wrap gap-2">
        <button onClick={save} disabled={!!busy || !dirty} className={`${btnCls} ${dirty ? "bg-blue-600 hover:bg-blue-500 text-white" : "bg-slate-700 text-slate-300"}`} data-testid={`${s.source}-save-urls-btn`}>
          {busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Linkleri Kaydet
        </button>
        <button onClick={() => run(() => reviewsApi.sourceSync(s.source, "incremental"), "inc", d => d.started ? "Yeni yorumlar çekiliyor…" : "Başlatılamadı (link yok veya zaten çalışıyor)")}
          disabled={!(s.urls || []).length || !!busy || running} className={`${btnCls} bg-emerald-600 hover:bg-emerald-500 text-white`} data-testid={`${s.source}-sync-btn`}>
          <RefreshCw className="w-4 h-4" /> Yeni Yorumları Çek
        </button>
        <button onClick={() => { if (window.confirm("Tüm geçmiş yorumlar Apify ile çekilecek (binlerce yorum, dakikalar sürebilir, Apify kredisi harcar). Devam?")) run(() => reviewsApi.sourceSync(s.source, "full"), "full", "Tüm geçmiş çekiliyor…"); }}
          disabled={!(s.urls || []).length || !!busy || running} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200`} data-testid={`${s.source}-full-sync-btn`}>
          <DownloadCloud className="w-4 h-4" /> Tüm Geçmişi Çek
        </button>
      </div>
      {running && (
        <div className="flex items-center gap-2 text-xs text-emerald-300 bg-emerald-900/20 border border-emerald-800/40 rounded-lg px-3 py-2" data-testid={`${s.source}-progress`}>
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          {p.mode === "full" ? "Tüm geçmiş" : "Yeni yorumlar"} · {p.pages ?? 0} sayfa · {p.fetched ?? 0} yorum · {p.inserted ?? 0} yeni · {p.suggested ?? 0} öneri
        </div>
      )}
      {!running && s.last_status === "ok" && p.fetched != null && (
        <div className="text-[11px] text-slate-400 flex items-center gap-1" data-testid={`${s.source}-last-result`}>
          <History className="w-3 h-3" /> Son çekim: {p.pages} sayfa · {p.fetched} yorum tarandı · {p.inserted} yeni · {p.matched} ref eşleşti · {p.suggested} isim önerisi{p.seconds ? ` · ${p.seconds}s` : ""}
        </div>
      )}
      {!!(s.urls || []).length && <div className="text-[11px] text-slate-500 flex items-center gap-1"><Link className="w-3 h-3" /> {(s.urls || []).length} link · 4 saatte bir otomatik (xx:27)</div>}
    </div>
  );
}
